import React from "react";
import { Layout } from "../../components/layout";
import { getConfig } from "../../config";
import styles from "./index.module.scss";

const { cardanoNetwork } = getConfig();

const NotFoundPage: React.FC = () => {
  return (
    <Layout mlmType={cardanoNetwork === "Mainnet" ? "NFTEAM" : "KWARXS"}>
      <div className={styles.notFoundContainer}>
        <h1>404 - Page Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
